import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=8e312984"
import script from "./projectOverview.vue?vue&type=script&lang=js"
export * from "./projectOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports